import {FC} from 'react';

interface RoundBadgeProps {
    amount: number;
    className?: string;
}

export const RoundBadge: FC<RoundBadgeProps> = ({amount, className = ''}) => {
    return (
        <span
            className={`flex min-w-[1rem] items-center justify-center rounded-full 
            bg-brand-950 font-bold text-brand-400 ${className}`}>
            {amount > 99 ? '99+' : amount} icons
        </span>
    );
};












